import { SVG_NAMESPACE } from '@recogito/annotorious/src/util/SVG';

export const getPointsBBox = (points) => {
  const xs = points.map(([x]) => x);
  const ys = points.map(([, y]) => y);

  const minX = Math.min(...xs);
  const minY = Math.min(...ys);
  const maxX = Math.max(...xs);
  const maxY = Math.max(...ys);

  return {
    x: minX,
    y: minY,
    w: Math.max(1, maxX - minX),
    h: Math.max(1, maxY - minY),
  };
};

export const getPathData = (points, originX = 0, originY = 0) =>
  points
    .map(([x, y], index) =>
      index === 0
        ? `M ${x - originX} ${y - originY}`
        : `L ${x - originX} ${y - originY}`,
    )
    .join(' ');

/**
 * Freehand strokes are stored as their bounding-box FragmentSelector (the
 * proven-render path in the installed Annotorious) plus the raw points and a
 * `shape` marker; the formatter draws the stroke itself.
 */
export const toFreehandTarget = (points, image) => {
  const bbox = getPointsBBox(points);

  return {
    source: image?.src,
    selector: {
      type: 'FragmentSelector',
      conformsTo: 'http://www.w3.org/TR/media-frags/',
      value: `xywh=pixel:${Math.round(bbox.x)},${Math.round(
        bbox.y,
      )},${Math.round(bbox.w)},${Math.round(bbox.h)}`,
      shape: 'freehand',
      points: points.map(([x, y]) => [Math.round(x), Math.round(y)]),
    },
  };
};

export const isFreehandAnnotation = (annotationOrData) => {
  const data = annotationOrData?.underlying || annotationOrData || {};
  const target = Array.isArray(data.targets) ? data.targets[0] : data.target;
  const rawSelector = target?.selector;
  const selector = Array.isArray(rawSelector) ? rawSelector[0] : rawSelector;

  return (
    selector?.type === 'FragmentSelector' &&
    selector.shape === 'freehand' &&
    Array.isArray(selector.points)
  );
};

export const createPathElement = (className) => {
  const path = document.createElementNS(SVG_NAMESPACE, 'path');

  if (className) {
    path.setAttribute('class', className);
  }

  path.setAttribute('fill', 'none');
  path.setAttribute('stroke-linecap', 'round');
  path.setAttribute('stroke-linejoin', 'round');

  return path;
};
